// Цены витрины. Раньше эти функции existовали в двух копиях (index и cart) и
// обязаны были совпадать — при расхождении на карточке и в корзине показывались
// разные цифры за один тариф.
import { api, type Config } from './api';

export const DEFAULT_CONFIG: Config = {
  title: 'Магазин',
  all_label: 'Все',
  show_all_category: true,
  show_old_price: true,
  old_price_multiplier: 2,
  welcome_enabled: true,
  desktop_enabled: false, // без конфига (нет initData на ПК) — блок
  theme: '1', // стандартный скин
  locale: 'ru', // язык по умолчанию — русский (канон)
};

let cfg: Config = DEFAULT_CONFIG;

export function config(): Config {
  return cfg;
}

/** Грузит настройки витрины. Провал не должен мешать показу — остаются дефолты. */
export async function loadConfig(): Promise<Config> {
  const loaded = await api.config().catch(() => null);
  if (loaded) cfg = loaded;
  return cfg;
}

/** Витринная «старая» цена: реальная × множитель, округление до …99. */
export function oldPrice(real: number): number {
  const x = (Number(real) || 0) * (cfg.old_price_multiplier || 2);
  return Math.max(99, Math.round(x / 100) * 100 - 1);
}

export function priceMarkup(real: number): string {
  const now = Number(real) || 0;
  if (!cfg.show_old_price) return `<span class="price-now">${now} ₽</span>`;
  const old = oldPrice(now);
  const save = old > 0 ? Math.round((1 - now / old) * 100) : 0;
  return (
    `<span class="price-old">${old} ₽</span>` +
    `<span class="price-now">${now} ₽</span>` +
    `<span class="price-save">−${save}%</span>`
  );
}
